import { FacebookEventNames, FacebookPurchaseParams } from '../../entities';
import { AppnebulaFacebookService, FacebookService } from '../../interfaces';

export class AppnebulaHttpFacebookService implements AppnebulaFacebookService {
  constructor(private readonly facebookService: FacebookService) {}

  purchase({ ltvPredict, paymentId, currency, channelInfo }: FacebookPurchaseParams) {
    this.facebookService.track(FacebookEventNames.PURCHASE, paymentId, {
      currency: currency,
      value: ltvPredict,
      ...(channelInfo && { channel_info: channelInfo }),
    });
  }

  addToCart(orderId: string) {
    this.facebookService.track(FacebookEventNames.ADD_TO_CART, orderId, {});
  }

  initiateCheckout(orderId: string) {
    this.facebookService.track(FacebookEventNames.INITIATE_CHECKOUT, orderId, {});
  }
}
